import { Menu } from '@mantine/core';
import { IconExternalLink, IconId } from '@tabler/icons-react';
import { useTranslate } from '@tolgee/react';

const keycloakUrl = import.meta.env.VITE_OIDC_ISSUER_URI;

const UserProfilMenuItem = () => {
  const { t } = useTranslate();

  return (
    <Menu.Item
      component="a"
      leftSection={<IconId stroke={1.5} />}
      rightSection={<IconExternalLink size={16} />}
      href={keycloakUrl + '/account'}
      target="_blank"
      rel="noopener noreferrer"
    >
      {t('nav.profil.profils')}
    </Menu.Item>
  );
};

export default UserProfilMenuItem;
